var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBusinessValues3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 52,
    viewBox: "0 0 68 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45737 44.2233V5.81982H2.61496C1.52331 5.81982 0.644531 6.69867 0.644531 7.78922V49.0833C0.644531 50.1634 1.52331 51.0421 2.61496 51.0421H60.5326C61.6115 51.0421 62.4915 50.1634 62.4915 49.0833V47.241H7.47499C5.8116 47.241 4.45737 45.8857 4.45737 44.2233Z",
    fill: "#2962FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9058 10.86L45.4976 6.40244L45.0634 5.04711C44.7987 4.22126 44.047 3.67065 43.1893 3.67065H25.7188L31.5952 10.86H46.9058Z",
    fill: "#2962FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3049 10.8601L59.5895 7.48249C59.2518 6.81542 58.5731 6.40247 57.8329 6.40247H46.6084L48.006 10.8601H61.3049Z",
    fill: "#2962FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3893 11.923H31.5239C31.2507 11.923 30.9944 11.8013 30.8208 11.5896L22.7229 1.68001C22.3491 1.22046 21.7933 0.957886 21.2014 0.957886H7.47898C6.39373 0.957886 5.51172 1.83989 5.51172 2.92302V44.2182C5.51172 45.3025 6.39373 46.1845 7.47898 46.1845H65.3893C66.4735 46.1845 67.3555 45.3025 67.3555 44.2182V13.8882C67.3555 12.805 66.4735 11.923 65.3893 11.923Z",
    fill: "#2962FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessValues3);
export default __webpack_public_path__ + "static/media/icon_business_values_3.3036797031d7983a2c6aaf1523922d67.svg";
export { ForwardRef as ReactComponent };